import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { MasterData, MasterDataService } from './master.data.service';

@Injectable({
  providedIn: 'root'
})
export class AppraiserService {
  private baseApiUrl: string;
   private documentPreviewUrl: string;
  appraiserList: Array<any>;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient,
    private masterDataService: MasterDataService,
    private masterData: MasterData) {
    this.baseApiUrl = configurationService.BaseApiUrl;
     this.documentPreviewUrl = `${configurationService.BasePreviewUrl}appraiserdocument/`;
    this.masterDataService.getAll([
      this.masterData.AppraiserType
    ])
      .subscribe(data => {
        this.appraiserList = data[0];
        console.log('Got data as ', data);
      },
        err => console.log('Get master data failed', err)
      );
  }

  getAppraiserType(id: number) : string {
    for (const appraiserType of this.appraiserList) {
      if (appraiserType.id === id) {
        return id = appraiserType.name;
      }
    }
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'appraiser/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'appraiser').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `appraiser/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(appraiser: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'appraiser', appraiser).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(appraiser: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'appraiser', appraiser).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(appraiserId: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'appraiser/authorise', appraiserId).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `appraiser/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  GetAppraiserByIdentifier(identifier: string, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `appraiser/identifier/${identifier}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getDocumentContentAsDataUrl(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(`${this.documentPreviewUrl}${id}?isMaintenance=${forMaintenance}`, { responseType: 'text' }).pipe(
      map(res => ({ id, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
